import { formValueSelector } from "redux-form";

import { IMPORT_ACTIVITY_TEMPLATE_NAME_FORM } from "~/constants/forms";

export const templateFormSelector = formValueSelector(
  IMPORT_ACTIVITY_TEMPLATE_NAME_FORM
);
